import {getServerTexts as getTexts, initTexts, texts} from '../../../../Localization/texts';

const entity = 'UI_NEWFORMS';

const en = {
    attachments: 'Attachments',
    number_of_attachments: 'Y (X attachments)',
    filter_option: 'Filters',
    clear_filters: 'Clear',
    format_of_file: 'Format',
    size_of_file: 'Size',
    the_user_who_updated_the_file_last: 'Modified by',
    the_date_the_file_was_created: 'File Creation Date',
    properties_of_file: 'Properties',
    confirm: 'OK',
    cancel: 'Cancel',
    settings_title: 'Show Data',
    clear_settings: 'Reset',
    label_readonly: 'Read-Only',
    label_not_for_sending: "Don't Send",
    tooltip: 'Set by Y X',
    preview: 'Preview',
    download: 'Download',
    rename: 'Rename',
    save: 'Save',
    delete: 'Delete',
    delete_question: 'Delete this file?',
    delete_confirmation: "We won't be able to recover deleted files.",
    delete_yes: 'Yes',
    dataexchange: 'Send by DataExchange',
    drop_file: 'Drop files here to attach or',
    browse: 'browse',
    drop_here: 'Drop your file here',
    file_saved: 'The file was uploaded successfully',
    empty_state_message: 'Attached files will appear here',
    empty_state__search_message: 'We did not find attachments that match your search.',
    attach_files: 'Add Attachments',
    top_100: 'See 100 attachments from all the results that match your',
    unsupported_format: 'The format you chose is not supported.',
    search_placeholder: 'Search...',
    history: 'History',
    statuses: 'Statuses',
    changes: 'Changes',
    status_cahnged: 'X changed the W to Y',
    single_change_log: 'X changed the W field from Y to Z',
    status_created: 'Created by X',
    changed_fields_count: 'X changed Y fields',
    change_bullet: 'X from Y to Z',
    file_upload: 'Uploading your file...',
    status_bullet: 'X to Y',
    change_wo_prev_val: 'X changed the W field to Z',
    changes_empty_state: 'Changes will appear here',
    changes_empty_state_search:
        'We did not find results that match your search. Check your spelling and try again.',
    change_wo_curr_val: 'X changed the W field from Y to an empty field',
    files_saved: 'The files were saved successfully',
    files_upload: 'Uploading your files...',
    file_download: 'Downloading your file…',
    promo_title: 'Quick Access',
    promo_attachments: 'Check out the new and easy way to add attachments to your documents.',
    promo_confirm: 'OK, got it',
    promo_show: 'Show me',
    promo_history: 'Quickly view the history and changes to your document.',
    cantChangeErrorMsg:
        'You cannot revise the attached file as it has defined as Read Only by X. To release the file for editing, contact your system manager',
    step2_title: 'Your AI-Powered Writing Assistant',
    step2_content:
        'Create emails that deliver results: speed up order approvals, increase response rates, and receive payments faster.\nAI helps you nail the right tone, polish your grammar, and find just the right words to get things done.',
    step3_title: 'Edit like a Pro',
    step3_content:
        'Design emails that stand out. Add formatted text, embed images, and express yourself with emojis - all with our powerful new editor.',
    step4_title: 'Back to Classic in a Click',
    step4_content: 'Switch between New and Classic anytime.',
    classic: 'Classic',
    new: 'New',
    toggle_tooltip: 'Switch between the Classic and New work experience.',
    feedback_title: 'Feedback to Priority',
    feedback_content:
        'Heading back to Classic?\nBefore you go, tell us why. Your feedback helps us make this experience better.',
    feedback_reason1: 'Missing functionality',
    feedback_reason2: 'Other',
    feedback_reason3: 'Tell us more',
    feedback_reason3_placeholder: 'What would make the new experience better for you?',
    feedback_contact_me: 'Priority may contact me about this feedback',
    feedback_to_classic: 'Back to Classic',
    feedback_stay_new: 'Stay with New',
    promo_popover_text: 'Choose New to unlock AI-powered writing and next-level',
    step1_title: 'Compose Mail Just Got Smarter',
    step1_content:
        'Introducing a smarter way to write emails.\nGet ready to experience AI-powered writing assistance, professional formatting tools, and a streamlined interface - all designed to help you create effective emails faster than ever.',
    unsupported_feature_title: 'Coming Soon',
    unsupported_feature_description:
        'This will soon be available in the New work experience.\n' +
        'In the meantime, you can click Back to Classic to continue using it.'
};

const he = {
    attachments: 'נספחים',
    number_of_attachments: 'Y (X נספחים)',
    filter_option: 'סינון',
    clear_filters: 'ניקוי',
    format_of_file: 'פורמט',
    size_of_file: 'גודל',
    the_user_who_updated_the_file_last: 'עודכן ע"י',
    the_date_the_file_was_created: 'תאריך יצירת מסמך',
    properties_of_file: 'מאפיינים',
    confirm: 'אישור',
    cancel: 'ביטול',
    settings_title: 'נתונים להצגה',
    clear_settings: 'איפוס',
    label_readonly: 'לקריאה בלבד',
    label_not_for_sending: 'לא לשליחה',
    tooltip: 'הוגדר ע"י X Y',
    preview: 'תצוגה מקדימה',
    download: 'הורדה',
    rename: 'שינוי שם',
    save: 'שמירה',
    delete: 'מחיקה',
    delete_question: 'למחוק את הקובץ?',
    delete_confirmation: 'המידע שימחק יאבד ולא נוכל לשחזר אותו.',
    delete_yes: 'כן',
    dataexchange: 'משלוח בממשק אלקטרוני',
    drop_file: 'אפשר לגרור לכאן קבצים או',
    browse: 'לבחור קובץ מתיקייה',
    drop_here: 'לשחרר את הקובץ כאן',
    file_saved: 'הקובץ נשמר בהצלחה',
    empty_state_message: 'כשיהיו נספחים לתעודה, הם יופיעו כאן',
    empty_state__search_message: 'אין נספחים שמתאימים לחיפוש שלך. כדאי לבדוק את האיות',
    attach_files: 'הוספת קובץ',
    top_100: 'מוצגים כאן 100 נספחים מתוך כל הנספחים המתאימים',
    unsupported_format: 'הפורמט שבחרת לא נתמך.',
    history: 'יומן שינויים',
    statuses: 'סטטוסים',
    changes: 'שינויים',
    search_placeholder: 'חיפוש...',
    status_cahnged: 'הW שונה על ידי X ל- Y',
    single_change_log: 'השדה W שונה על ידי X מ- Y ל- Z',
    status_created: 'יצירה ראשונית על ידי X',
    changed_fields_count: 'X שדות שונו על ידי Y',
    change_bullet: 'X מ - Y ל - Z',
    file_upload: 'מעלים את הקובץ שלך...',
    status_bullet: 'X ל- Y',
    change_wo_prev_val: 'השדה W שונה על ידי X ל- Z',
    changes_empty_state: 'שינויים בתעודה יופיעו כאן.',
    changes_empty_state_search: 'אין נתונים המתאימים לחיפוש. כדאי לבדוק את האיות שוב.',
    change_wo_curr_val: 'השדה W שונה מ-Y לשדה ריק על ידי X.',
    files_saved: 'הקבצים נשמרו בהצלחה',
    files_upload: 'מעלים את הקבצים שלך...',
    file_download: 'אנחנו מורידים את הקובץ...',
    promo_title: 'גישה מהירה',
    promo_attachments: 'דרך חדשה ונוחה לצרף נספחים לתעודות שלך.',
    promo_confirm: 'הבנתי',
    promo_show: 'ספרו לי עוד',
    promo_history: 'מבט מהיר על היסטוריית השינוי של התעודה.',
    cantChangeErrorMsg:
        'ינך יכול לשנות את הקובץ המצורף כפי שהוגדר כקריאה בלבד על ידי X. כדי לשחרר את הקובץ לעריכה, פנה למנהל המערכת שלך',
    step2_title: 'עריכת אימיילים חכמה באמצעות AI',
    step2_content:
        'כתבו אימיילים שעובדים בשבילכם: \nזרזו אישורי הזמנות, הגדילו אחוזי תגובה וקבלו תשלומים מהר יותר.\nבעזרת AI תמצאו את הטון המדויק, הניסוח המושלם והמילים שמניעות לפעולה.',
    step3_title: 'קפיצת מדרגה ביצירת אימיילים מקצועיים',
    step3_content:
        "מעכשיו האימיילים שלכם ייראו אחרת. השתמשו ביכולות עיצוב מתקדמות, הוסיפו תמונות ותנו לאימוג'ים להוסיף את הטאץ' האישי לאימייל המקצועי שלכם.",
    step4_title: 'תמיד אפשר לחזור חזרה לחוויית העבודה הקלאסית',
    step4_content: 'בקליק אחד אפשר לחזור לחוויית העבודה הקלאסית המוכרת.',
    classic: 'קלאסי',
    new: 'חדש',
    toggle_tooltip: 'בחרו בין חוויית עבודה קלאסית לחדשה.',
    feedback_title: 'משוב ל- Priority',
    feedback_content: 'חוזרים לקלאסי?\nחשוב לנו לדעת מה הסיבה כדי שנוכל לשפר את החוויה.',
    feedback_reason1: 'פונקציונליות חסרה',
    feedback_reason2: 'סיבה אחרת',
    feedback_reason3: 'ספרו לנו עוד',
    feedback_reason3_placeholder: 'ספרו לנו מה הייתם רוצים לשפר.',
    feedback_contact_me: 'אפשר ליצור איתי קשר לגבי המשוב',
    feedback_to_classic: 'חזרה לתצוגה הקלאסית',
    feedback_stay_new: 'להישאר בתצוגה החדשה',
    promo_popover_text: 'בחרו ב"חדש" וגלו איך AI עוזר לכם לכתוב אימיילים',
    step1_title: 'החוויה החדשה של כתיבת אימיילים כבר כאן',
    step1_content:
        'הכירו דרך חכמה וקלה יותר לכתוב אימיילים.\nגלו את הכוח של כתיבה מבוססת AI, כלי עיצוב מקצועיים וממשק יעיל שנועד לעזור לכם ליצוראימיילים אפקטיביים מהר מתמיד.',
    unsupported_feature_title: 'יש למה לחכות',
    unsupported_feature_description:
        'אפשרות זו תהיה זמינה בקרוב בתצוגה החדשה.\n' + 'בינתיים, תוכלו להשתמש בה בתצוגה הקלאסית.'
};

const fallbacks = {en, he};

export const mapping = {
    1: 'attachments',
    2: 'number_of_attachments',
    3: 'filter_option',
    4: 'clear_filters',
    5: 'format_of_file',
    6: 'size_of_file',
    7: 'the_user_who_updated_the_file_last',
    8: 'the_date_the_file_was_created',
    9: 'properties_of_file',
    10: 'confirm',
    11: 'cancel',
    12: 'settings_title',
    13: 'clear_settings',
    14: 'label_readonly',
    15: 'label_not_for_sending',
    16: 'tooltip',
    17: 'preview',
    18: 'download ',
    19: 'rename',
    20: 'save',
    21: 'delete',
    22: 'delete_question',
    23: 'delete_confirmation',
    24: 'delete_yes',
    25: 'dataexchange',
    26: 'drop_file',
    27: 'browse',
    28: 'drop_here',
    29: 'file_saved',
    30: 'empty_state_message',
    31: 'attach_files',
    32: 'top_100',
    33: 'unsupported_format',
    34: 'history',
    36: 'statuses',
    37: 'changes',
    38: 'search_placeholder',
    66: 'status_cahnged',
    67: 'single_change_log',
    68: 'status_created',
    69: 'changed_fields_count',
    70: 'change_bullet',
    71: 'empty_state__search_message',
    72: 'file_upload',
    73: 'status_bullet',
    87: 'file_download',
    88: 'change_wo_prev_val',
    89: 'changes_empty_state',
    90: 'changes_empty_state_search',
    91: 'change_wo_curr_val',
    92: 'files_saved',
    93: 'files_upload',
    94: 'promo_title',
    95: 'promo_attachments',
    96: 'promo_confirm',
    97: 'promo_show',
    98: 'promo_history',
    101: 'classic',
    102: 'new',
    103: 'toggle_tooltip',
    104: 'step2_title',
    105: 'step2_content',
    106: 'step3_title',
    107: 'step3_content',
    110: 'step4_title',
    111: 'step4_content',
    115: 'promo_popover_text',
    116: 'feedback_title',
    117: 'feedback_content',
    118: 'feedback_reason1',
    119: 'feedback_reason2',
    120: 'feedback_reason3',
    121: 'feedback_reason3_placeholder',
    122: 'feedback_contact_me',
    123: 'feedback_to_classic',
    124: 'feedback_stay_new',
    125: 'step1_title',
    126: 'step1_content',
    128: 'unsupported_feature_title',
    129: 'unsupported_feature_description'
};

export const getServerTexts = () => getTexts(entity, mapping);

initTexts(entity, fallbacks);

export default texts[entity] as typeof en;
